import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid p-2" }
const _hoisted_3 = { class: "col-12 flex justify-content-start align-content-center" }
const _hoisted_4 = { class: "flex relative gap-1 align-items-center justify-content-start" }
const _hoisted_5 = { class: "payment-details" }
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = { class: "col-12" }

import { onMounted, ref, watch, computed } from 'vue';
import { storeToRefs } from 'pinia';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Calendar from 'primevue/calendar';
import { usePaymentStore, useOrganizationStore } from '@/store';
import { useCurrency, useDateTime } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'Payment',
  setup(__props) {

const expandedRows = ref();
const paymentStore = usePaymentStore();
const organizationStore = useOrganizationStore();
const { payments, start_at, end_at } = storeToRefs(paymentStore);
const { organizationsIdsSelected } = storeToRefs(organizationStore);

const getPayments = async () => {
  if (!datesInverted.value) await paymentStore.getCurrentUserPayments(organizationsIdsSelected.value);
};

onMounted(getPayments);

watch([start_at, end_at, organizationsIdsSelected], getPayments);

const datePeriodText = (start: string, end: string) => {
  const str = useDateTime().checkProperIntlFormatting(start);

  const dtf = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
  });

  const startPeriod = dtf.format(Date.parse(str));
  const endPeriod = new Date(end);

  return `${startPeriod} - ${useDateTime().formatDateShortMonth(endPeriod.toString())}`;
};

const datesInverted = computed(() => {
  return start_at.value && end_at.value ? start_at.value >= end_at.value : false;
});

/**
 * make the selected end date the last day of that month
 * @param value = end date string
 */
const updateEndDate = (value: string) => {
  end_at.value = new Date(useDateTime().getEndOfMonthDate(value, 1));
};

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Calendar), {
                modelValue: _unref(start_at),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(start_at) ? (start_at).value = $event : null)),
                view: "month",
                class: "w-9rem text-sm",
                "date-format": "MM yy"
              }, null, 8, ["modelValue"]),
              _cache[3] || (_cache[3] = _createTextVNode(" to ", -1)),
              _createVNode(_unref(Calendar), {
                modelValue: _unref(end_at),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(end_at) ? (end_at).value = $event : null)),
                view: "month",
                class: "w-9rem text-sm",
                "date-format": "MM yy",
                onDateSelect: updateEndDate
              }, null, 8, ["modelValue"])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "note flex align-items-center ml-4 font-normal" }, [
              _createElementVNode("strong", null, "Note:"),
              _createTextVNode("  This payment data does not include manual adjustment. ")
            ], -1))
          ])
        ]),
        _createVNode(_unref(DataTable), {
          expandedRows: expandedRows.value,
          "onUpdate:expandedRows": _cache[2] || (_cache[2] = ($event: any) => ((expandedRows).value = $event)),
          "filter-display": "menu",
          value: _unref(payments),
          "total-records": _unref(paymentStore).total,
          "data-key": "bucket_start_at",
          "row-hover": true,
          lazy: true,
          "loading-icon": "logo-spinner",
          loading: _unref(paymentStore).loading,
          "responsive-layout": "scroll"
        }, {
          empty: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("No Payment Found", -1)
          ]))]),
          loading: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("Loading data. Please wait.", -1)
          ]))]),
          expansion: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(DataTable), {
                      value: slotProps.data.events,
                      "data-key": "event_id",
                      class: "px-3",
                      "row-hover": true,
                      lazy: true,
                      "responsive-layout": "scroll"
                    }, {
                      empty: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("No Events Found", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_unref(Column), {
                          field: "start_at",
                          header: "Date",
                          "header-class": "no-center details-table-header py-0"
                        }, {
                          body: _withCtx(({ data }) => [
                            _createTextVNode(_toDisplayString(_unref(useDateTime)().formatDateShortMonth(data.start_date)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Column), {
                          field: "time",
                          header: "Time",
                          "body-class": "text-center",
                          "header-class": "details-table-header py-0"
                        }, {
                          body: _withCtx(({ data }) => [
                            _createTextVNode(_toDisplayString(`${data.start_time} - ${data.end_time}`), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Column), {
                          field: "completed_at",
                          header: "Documented",
                          "body-class": "text-center",
                          "header-class": "details-table-header py-0"
                        }, {
                          body: _withCtx(({ data }) => [
                            _createTextVNode(_toDisplayString(data.completed_at), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Column), {
                          field: "organization_name",
                          header: "Customer",
                          "body-class": "text-center",
                          "header-class": "details-table-header py-0"
                        }),
                        _createVNode(_unref(Column), {
                          field: "event_type",
                          header: "Event Type",
                          "body-class": "text-center",
                          "header-class": "details-table-header py-0"
                        }),
                        _createVNode(_unref(Column), {
                          field: "duration",
                          header: "Duration",
                          "body-class": "text-center",
                          "header-class": "details-table-header py-0"
                        }),
                        _createVNode(_unref(Column), {
                          field: "rate",
                          header: "Rate",
                          "body-class": "text-center",
                          "header-class": "details-table-header py-0"
                        }, {
                          body: _withCtx(({ data }) => [
                            _createTextVNode(_toDisplayString(_unref(useCurrency)().formatCurrency(data.rate)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              field: "",
              expander: true,
              "header-class": "no-center",
              "header-style": "width: 20px"
            }),
            _createVNode(_unref(Column), {
              field: "period",
              header: "Payment Period",
              "header-class": "no-center col-2"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(datePeriodText(data.bucket_start_at, data.bucket_end_at)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "type",
              header: "Type",
              "body-class": "text-center capitalize"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.events[0]?.payment_type || 'N/A'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "hours",
              header: "Hours",
              "body-class": "text-center"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.hours.toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "total",
              header: "Total",
              "body-class": "text-center"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_unref(useCurrency)().formatCurrency(data.total)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "count",
              header: "Events",
              "body-class": "text-center"
            })
          ]),
          _: 1
        }, 8, ["expandedRows", "value", "total-records", "loading"])
      ]),
      _: 1
    })
  ]))
}
}

})